import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { InvitationState, InvitePreview, AcceptInviteResult } from './types';

const initialState: InvitationState = {
  loading: false,
  error: null,
  preview: null,
  accepting: false,
  acceptError: null,
  accepted: false,
  acceptedOrgGuid: null,
  acceptedOrgName: null
};

export const slice = createSlice({
  name: 'orgInvitation',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.error = null;
    },
    loadSuccess(state, action: PayloadAction<InvitePreview>) {
      state.loading = false;
      state.preview = action.payload;
    },
    loadError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    startAccepting(state) {
      state.accepting = true;
      state.acceptError = null;
    },
    acceptSuccess(state, action: PayloadAction<AcceptInviteResult>) {
      state.accepting = false;
      state.accepted = true;
      state.acceptedOrgGuid = action.payload.organizationGuid;
      state.acceptedOrgName = action.payload.organizationName;
    },
    acceptError(state, action: PayloadAction<string>) {
      state.accepting = false;
      state.acceptError = action.payload;
    }
  }
});

export default slice.reducer;
